import { Circles } from "react-loader-spinner";
import styles from "./main.module.css";

const Main = () => {
  return (
    <div className={styles.loader}>
      <Circles height="80" width="80" color="#189056" ariaLabel="loading" />
    </div>
  );
};

export default Main;
